<template>
	<div id="page-wrapper" style="height:100%">
		<el-container>
		  <el-header style="height: 50px;">
		  	<h3 style="margin-top:8px;">
		  		{{ $t('mind.title') }} &nbsp;
		  		<el-input :placeholder="$t('mind.keyword-ph')" size="medium" v-model="keyword" style="width: 200px;">
	          	  <el-button slot="append" size="medium" icon="el-icon-search" @click="searchMind"></el-button>
				</el-input>&nbsp;

				<el-button type="success" icon="el-icon-plus" size="medium"
				 style="padding: 10px 10px" :disabled="canNew" @click="createNew"></el-button>
				 <input id="file_input" class="file_input" type="file" style="display:none" />
		  	</h3>
		  	<div class="jsmind-tools">
		      	<h3>
		      	<el-tooltip class="item" effect="dark" :content="$t('mind.add')" placement="top">
		      		<i class="el-icon-plus" style="margin:5px" @click="addNode"></i> 
		      	</el-tooltip>
		      	<el-tooltip class="item" effect="dark" :content="$t('mind.edit')" placement="top">
		      		<i class="el-icon-edit" style="margin:5px" @click="editNode"></i> 
		      	</el-tooltip>
		      	<el-tooltip class="item" effect="dark" :content="$t('mind.remove')" placement="top">
					<i class="el-icon-delete" style="margin:5px" @click="removeNode"></i>
				</el-tooltip>

		      	<el-tooltip class="item" effect="dark" :content="$t('mind.open')" placement="top">
					<i class="el-icon-folder-opened" style="margin:5px" @click="openFile"></i> 
				</el-tooltip>
		      	<el-tooltip class="item" effect="dark" :content="$t('mind.download')" placement="top">
					<i class="el-icon-download" style="margin:5px" @click="saveFile"></i> 
				</el-tooltip>
				<el-tooltip class="item" effect="dark" :content="$t('mind.save')" placement="top">
					<i class="fa fa-floppy-o" style="margin:5px" @click="saveData"></i> 
				</el-tooltip>
				<el-tooltip class="item" effect="dark" :content="$t('mind.save-image')" placement="top">
					<i class="el-icon-camera" style="margin:5px" @click="saveImage"></i> 
				</el-tooltip>
				
				<el-tooltip class="item" effect="dark" :content="$t('mind.share')" placement="top">
					<i class="el-icon-share" style="margin:5px" @click="shareMap"></i>
				</el-tooltip>
				<el-tooltip class="item" effect="dark" :content="$t('mind.zoom-in')" placement="top">
					<i class="el-icon-circle-plus-outline" style="margin:5px" @click="zoomIn"></i>
				</el-tooltip>
				<el-tooltip class="item" effect="dark" :content="$t('mind.zoom-out')" placement="top">
					<i class="el-icon-remove-outline" style="margin:5px" @click="zoomOut"></i>
				</el-tooltip>
				<span class="hide">
					<el-color-picker ref="colorPicker" v-model="color" size="mini" @change="setColor" popper-class="color-picker"></el-color-picker>
				</span>
				<el-tooltip class="item" effect="dark" :content="$t('mind.color')" placement="top">
					<i class="el-icon-picture-outline-round" style="margin:5px" @click="openColorPicker"></i>
				</el-tooltip>
				</h3>
		    </div>
		  </el-header>
		  <el-container>
		    <el-aside width="250px">
			  	<section>
                    <section>
                      <section>
                        <div class="padder" style="margin-top:20px">
                          <ul id="note-items" class="list-group">
                          	<li class="list-group-item hover" 
                          		v-for="n in filteredMinds"
                          		:class="{ active: n.id == mind.id }"
                          		@click="selectMind(n)">
                              <div class="view">
                              	<el-popconfirm
								  :title="$t('mind.confirm')"
								  :confirmButtonText="$t('mind.yes')"
  								  :cancelButtonText="$t('mind.no')"
  								  @onConfirm="deleteMindMap(n.id)"
								>
                                <button slot="reference" class="destroy close hover-action">×</button>
                                </el-popconfirm>
                                <div class="note-name text-ellipsis">
                                  <strong>
                                  {{ n.map.meta.name }}
                                  </strong>
                                </div>
                                
                                <span class="text-xs text-muted">{{ n.date }}</span>
                              </div>
                            </li>
                          </ul>
                            
                          <p class="text-center">&nbsp;</p>
                        </div>
                      </section>
                    </section>
                  </section>
                </section>
		    </el-aside>
		    <el-main>
		      <div id="jsmind_container"></div>
		      
			</el-main>
		  </el-container>
		</el-container>
		<!--User Modal -->
		<el-dialog :title="$t('mind.share')" 
			:visible.sync="showShareForm"
			width="70%"
			top="30px"
			:append-to-body="true"
			:close-on-click-modal="false">
			<div style="text-align: center">
	            <el-transfer 
	            	filterable
	    			:filter-method="filterMethod"
	 				v-model="selectedUsers"
	 				:titles="[$t('mind.user-list'), $t('mind.target')]"
	 				:data="userData"
	 				style="text-align: left; display: inline-block">
	 			</el-transfer>
 			</div>
 			<div style="margin: 10px 0px 0px 20px">
 				<el-checkbox v-model="readonly">{{ $t('mind.readonly') }}</el-checkbox>
 			</div>
            <div slot="footer" class="dialog-footer">
			    <el-button @click="showShareForm = false">{{ $t('mind.cancel') }}</el-button>
			    <el-button type="primary" @click="shareToUsers">{{ $t('mind.yes') }}</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<style>
  .color-picker {
    top: 80px !important;
    right: 10px !important;
    left: auto !important;
  }
</style>
<style scoped>
  .hide {
	display: none;
	visibility: hidden;
  }
  .el-container {
    height: 100vh;
  }
  .el-header {
    position: relative;
    background-color: #fcfcfd;
    color: #333;
    line-height: 50px;
    height: 50px;
  }
  
  .el-aside {
    background-color: #D3DCE6;
    color: #333;
    text-align: left;
    height: 100vh;
  }
  
  .el-main {
  	position: relative;
    background-color: #E9EEF3;
    color: #333;
    text-align: center;
    padding: 0;
    margin: 0;
    border: 0;
  }
  #jsmind_container {
    height: 100vh;
    width: 100%;
  }
  .jsmind-tools {
    position: absolute;
    z-index: 2;
    top: 5px;
    right: 10px;
    border: solid 1px #eee;
    background-color: #ececed;
    border-radius: 5px;
    opacity: 0.8;
    height: 40px;

}
/*List hover*/
.list-group-item{border-color:#e4e9ed;}
.list-group-item .fa-chevron-right{float: right;margin-top: 4px;margin-right: -5px}
.list-group-item > .fa-chevron-right + .badge {margin-right: 5px;}
li.list-group-item:hover, a.list-group-item:focus, a.list-group-item:active {background-color: #f1f5f9;}
li.list-group-item.active{background-color: #e1e5e9;border-color:#e1e5e9;color: #3a5a7a}
li.list-group-item.active > .badge, .nav-pills > .active > a > .badge{color: #3a5a7a}
.list-group-item.active a, .list-group-item.active .text-muted{color: #fff}
.list-group-item.active{background-color: #5191d1;border-color:#5191d1;}
.list-group-item.media{margin-top: 0}
.padder {
  padding-left: 15px;
  padding-right: 15px;
}
.padder-v {
  padding-top: 15px;
  padding-bottom: 15px;
}
.no-padder {
  padding: 0 !important;
}
.list-group {
  border-radius: 2px;
}
.list-group.no-radius .list-group-item {
  border-radius: 0 !important;
}
.list-group.no-borders .list-group-item {
  border: none;
}
.list-group.no-border .list-group-item {
  border-width: 1px 0;
}
.list-group.no-bg .list-group-item {
  background-color: transparent;
}
.list-group-item {
  border-color: #eaeef1;
  padding-right: 15px;
}
a.list-group-item:hover,
a.list-group-item:focus {
  background-color: #f9fafc;
}
.list-group-item.media {
  margin-top: 0;
}
.list-group-item.active {
  color: #fff;
  border-color: #1ccacc !important;
  background-color: #1ccacc !important;
}
.list-group-item.active .text-muted {
  color: #91eff0;
}
.list-group-item.active a {
  color: #fff;
}
.list-group-alt .list-group-item:nth-child(2n+2) {
  background-color: rgba(0,0,0,0.02) !important;
}
.list-group-lg .list-group-item {
  padding-top: 15px;
  padding-bottom: 15px;
}
.list-group-sp .list-group-item {
  margin-bottom: 5px;
  border-radius: 3px;
}
.list-group-item > .badge {
  margin-right: 0;
}
.list-group-item > .fa-chevron-right {
  float: right;
  margin-top: 4px;
  margin-right: -5px;
}
.list-group-item > .fa-chevron-right + .badge {
  margin-right: 5px;
}
</style>
<script>
import jsMindMap from 'jsmind/js/jsmind.js'
import 'jsmind/style/jsmind.css'
import Hashids from 'hashids'
import moment from 'moment'

export default {
  name: 'Mind',
  props: ['users'],
  data: function () {
    return {
      active: true,
      keyword: null,
      color: null,
      minds: [],
      mind: {
        "id": null,
        "userId": localStorage.getItem('token'),
        "date": moment().format('YYYY-MM-DD HH:mm:ss'),
	    "map": {
	      	"meta": {
	          "name": "New Mind Map",
	          "author": "",
	          "version": "0.2"
	        },
	        "format": "node_array",
	        "data": [
	          {"id": "root", "isroot": true, "topic": "Root node"}
	        ]
	      }
      },
      options: {
        container: 'jsmind_container',
        editable: true,
        theme: 'nephrite'
      },
      jm: null,
      showShareForm: false,
      selectedUsers: [],
      currentId: null,
      readonly: false
    }
  },
  computed: {
    filteredMinds: function() {
      let k = this.keyword ? this.keyword.toLowerCase() : ''
      if (!this.minds) return []
      return this.minds.filter(item => {
		if (item.map.meta.name.toLowerCase().includes(k)) {
		  return item
		}
	  })
    },
    canNew: function() {
      for (let i = 0; i < this.minds.length; i ++) {
        if (this.minds[i].id == null) return true
      }
      return false
    },
    userData: function() {
      let d = []
      this.users.forEach((user, index) => {
        d.push({
          label: user.name,
          key: user.id
        })
      })
      return d
    }
  },
  mounted: function () {
    require('jsmind/js/jsmind.draggable.js')
    require('jsmind/js/jsmind.screenshot.js')
    this.loadMinds()
  },
  methods: {
    selectMind: function(m) {
      this.mind = m
      this.currentId = m.id
      console.log(this.currentId)
      //this.loadData()
      this.jm.show(m.map)
    },
    deleteMindMap: function(nid) {
        //console.log(nid)
    	if (nid == null) {
    	  //TO DO
    	} else {
          let d = {
            'userId': localStorage.getItem('token'),
            'ids': [],
            'source': 'mind'
          },
          that = this
	      d['ids'].push(nid)
          this.$http.post(this.API3_PREFIX + 'del_records', d).then(function (response) {
	        that.$message({
	          message: that.$t('mind.delete-success'),
	          type: 'success'
	        })
            for (let i = 0; i < that.minds.length; i ++) {
	          if (that.minds[i].id == nid)
	            that.minds.splice(i,1)

	          if (i == 0) {
	            if (that.minds.length > 0) {
				  that.mind = that.minds[0]
				  that.currentId = that.mind.id
				  that.jm.show(that.mind.map)
				} else
				  that.createNew()
	          }
            }
          }).catch(function (error) {
            console.log(error)
            that.$message({
              message: that.$t('mind.delete-failed'),
              type: 'error'
            })
          })
    	}
    },
    createNew: function() {
      this.minds.unshift({
        "id": null,
        "userId": localStorage.getItem('token'),
        "date": moment().format('YYYY-MM-DD HH:mm:ss'),
	    "map": {
	      	"meta": {
	          "name": "New Mind Map",
	          "author": "",
	          "version": "0.2"
	        },
	        "format": "node_array",
	        "data": [
	          {"id": "root", "isroot": true, "topic": "Root node"}
	        ]
	      }
      })
      this.mind = this.minds[0]
      //this.loadData()
      this.currentId = this.mind.id
      this.jm.show(this.mind.map)
    },
    saveImage: function() {
      this.jm.screenshot.shootDownload()
    },
    saveFile: function() {
        let mind_data = this.jm.get_data(),
        	mind_name = mind_data.meta.name,
        	mind_str = jsMind.util.json.json2string(mind_data)
        jsMind.util.file.save(mind_str, 'text/jsmind', mind_name + '.mmap');
    },
    openFile: function() {
        let file_input = document.getElementById('file_input')
        let files = file_input.files,
        	that = this
        if(files.length > 0) {
            let file_data = files[0]
            jsMind.util.file.read(file_data, function(jsmind_data, jsmind_name) {
                let mind = jsMind.util.json.string2json(jsmind_data)
                if(!!mind) {
                    this.minds.unshift(mind)
                    that.jm.show(mind.map)
                } else {
                    that.$message({
			          message: that.$t('mind.open-fail'),
			          type: 'success'
			        })
                }
            })
        }else{
            this.$message({
	          message: that.$t('mind.no-choose'),
	          type: 'success'
	        })
        }
    },
    filterMethod: function(query, item) {
      return item.label.indexOf(query) > -1
    },
    shareToUsers: function() {
      console.log(this.selectedUsers)
    },
    shareMap: function() {
      this.showShareForm = true
    },
    openTitle: function() {
        let that = this
        this.$prompt(this.$t('mind.input-title'), this.$t('mind.input-title-tip'), {
          confirmButtonText: this.$t('mind.yes'),
          cancelButtonText: this.$t('mind.no')
        }).then(({ value }) => {
          this.mind.map = this.jm.get_data()
          this.mind.map.meta.name = value
          this.mind.map.meta.author = localStorage.getItem('token')
          this.mind.shareTo = this.selectedUsers
          this.mind.userId = localStorage.getItem('token')
	      
	      this.$http.post(this.API3_PREFIX + 'mind', this.mind).then(function (response) {
	        that.$message({
	          message: that.$t('mind.save-success'),
	          type: 'success'
	        })
	      }).catch(function (error) {
	        console.log(error)
	        that.$message({
	          message: that.$t('mind.save-failed'),
	          type: 'error'
	        })
	      })
        }).catch(() => {
                
        })
    },
    openColorPicker: function() {
      //console.log(this.$refs.colorPicker)
      this.$refs.colorPicker.showPicker = true
    },
    zoomIn: function() {
      this.jm.view.zoomIn()
    },
    zoomOut: function() {
      this.jm.view.zoomOut()
    },
    setColor: function() {
      let node = this.jm.get_selected_node()
      this.jm.set_node_color(node.id, this.color, '')
    },
    saveData: function() {
      if (this.mind.map.meta.name == 'New Mind Map')
          this.openTitle()
      else {
          this.mind.map = this.jm.get_data()
          this.mind.map.meta.author = localStorage.getItem('token')
          this.mind.shareTo = this.selectedUsers
          this.mind.userId = localStorage.getItem('token')

	      let that = this
	      this.$http.post(this.API3_PREFIX + 'mind', this.mind).then(function (response) {
	        that.$message({
	          message: that.$t('mind.save-success'),
	          type: 'success'
	        })
	      }).catch(function (error) {
	        console.log(error)
	        that.$message({
	          message: that.$t('mind.save-failed'),
	          type: 'error'
	        })
	      })
      }
    },
    removeNode: function() {
      let node = this.jm.get_selected_node()
      this.jm.remove_node(node.id)
    },
    editNode: function() {
      let node = this.jm.get_selected_node()
      this.jm.begin_edit(node.id)
    },
    addNode: function() {
      let node = this.jm.get_selected_node(),
          date = new Date(),
	      time = date.getTime(),
	      hashids = new Hashids('catpoint')
      this.jm.add_node(node.id, hashids.encode(time), 'New node')
    },
    searchMind: function() {

    },
    loadData: function () {
      this.jm = jsMind.show(this.options, this.mind.map)
      // jm.set_readonly(true);
      // var mind_data = jm.get_data();
    },
    loadMinds: function() {
      let that = this,
          query = '?userId=' + localStorage.getItem('token')

	  this.$http.get(this.API3_PREFIX + 'minds' + query).then(function (response) {

		that.minds = response.data
		/*m.forEach(function(i, k) {
		  i.data.meta.id = i.id
		  i.data.meta.date = i.createAt
		  that.minds.push(i.data)
		})*/
		
		if (that.minds.length > 0) {
		  that.mind = that.minds[0]
		  that.currentId = that.mind.id
		  console.log(that.mind)
		  that.loadData()
		} else
		  that.createNew()

      }).catch(function (error) {
		console.log(error)
      })
    }
  },
  created: function() {
    window.jsMind = jsMindMap
    //this.loadMinds()
  }
}
</script>